import axios from "axios";
import { POST_LOGIN_KEY } from "@/lib/postLogin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Keep imports safe: the app root renders the configuration screen before mounting routes.
export const CONFIG_ERROR = !BACKEND_URL;
export const API = CONFIG_ERROR ? undefined : `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach token on every request
api.interceptors.request.use((config) => {
  // Do not let an accidental request fall back to the current origin without configuration.
  if (CONFIG_ERROR) return Promise.reject(new Error("De app is niet goed ingesteld."));
  const token = localStorage.getItem("tw1_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Clear token on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("tw1_token");
      // Force redirect to login (only if not already on login)
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/login")) {
        try {
          window.sessionStorage.setItem(POST_LOGIN_KEY, window.location.pathname + window.location.search);
        } catch {
          /* fail-soft: login still works, only the deep link is lost */
        }
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" · ");
  if (d?.msg) return d.msg;
  return String(d);
}
